import { useEffect as e, useMemo as t, useRef as n } from "react";
// src/design/forms/datepicker/hooks/use-callback-ref.ts
function r(r) {
	let i = n(r);
	return e(() => {
		i.current = r;
	}), t(() => ((...e) => i.current?.(...e)), []);
}
export { r as useCallbackRef };

//# sourceMappingURL=use-callback-ref.js.map